import { FlexColumnDiv } from '@/app/shared/common.StyledComponents';
import { formatMoney } from '@/app/shared/utils/tableUtils';
import { numberStringTocommaString } from '@/app/shared/utils/utils';
import {
  AccentNumber,
  ButtonSizes,
  ButtonV2,
  ButtonVariants,
  H2,
  Icon,
  LoadingIndicator,
  Paragraph,
} from '@triumph/design-system';
import { useTranslation } from 'react-i18next';
import {
  CardHeader,
  FilterLink,
  InvoicesAmount,
  InvoicesSummaryDetailCard,
} from './InvoicesSummary.StyledComponents';
import { InvoiceSummaryCardItem } from './invoicesSummary.types';

export const InvoicesSummaryCard: React.FC<InvoiceSummaryCardItem> = ({
  totalAmount,
  count,
  headerText,
  iconName,
  iconColor,
  onChangeFilter,
  isLoading = false,
}) => {
  const { t } = useTranslation('invoicesDashboard');

  if (isLoading) {
    return (
      <InvoicesSummaryDetailCard>
        <LoadingIndicator show={true} />
      </InvoicesSummaryDetailCard>
    );
  }

  return (
    <InvoicesSummaryDetailCard>
      <CardHeader>
        <Icon
          color={iconColor}
          name={iconName}
          id={'success-check-icon'}
          size={'md'}
        />
        <FlexColumnDiv>
          <H2>
            <b>{headerText}</b>
          </H2>
          <Paragraph
            small
            bold
          >{`${numberStringTocommaString(count)} ${t('invoicesSummary.invoices')}`}</Paragraph>
        </FlexColumnDiv>
        <FilterLink>
          <ButtonV2
            type="button"
            size={ButtonSizes.small}
            variant={ButtonVariants.tertiary}
            onClick={() => onChangeFilter()}
          >
            {t('invoicesSummary.viewInvoices')}
          </ButtonV2>
        </FilterLink>
      </CardHeader>
      <InvoicesAmount>
        <AccentNumber>{formatMoney(totalAmount)}</AccentNumber>
      </InvoicesAmount>
    </InvoicesSummaryDetailCard>
  );
};
